var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},_vm._l((_vm.orderDetails.cart),function(material){return _c('div',{key:material.id,staticClass:"card card-no-padding card-body mt-3"},[_c('app-material',{attrs:{"material":material}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }